export const PipelineTemplates = {
  addExtendedAttributes: require('core/pipeline/config/stages/bake/modal/addExtendedAttribute.html'),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/stages/templates/index.ts